import { render, staticRenderFns } from "./RegistrationXPanel.vue?vue&type=template&id=06aabbc8"
import script from "./RegistrationXPanel.vue?vue&type=script&lang=js"
export * from "./RegistrationXPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports